import styled from 'styled-components';
import { StyledDialogContent } from '~/components/dialog/styles/styled-dialog';
import { breakPoints } from '~/styles/break-points';

export const StyledConflictDialogWrapper = styled.div`
	${StyledDialogContent} {
		padding-top: 0;

		${breakPoints({
			'1024': `
				padding-top: 0;
			`,
		})}
	}
`;

export const StyledConflictDialog = styled.div`
	display: flex;
	flex-direction: column;
	gap: 48px;
	padding-top: 48px;

	${breakPoints({
		'1024': `
			padding-top: 64px;
		`,
	})}
`;
